import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/close.png';
const _hoisted_1 = {
    key: 0,
    class: "divider"
};
const _hoisted_2 = {
    key: 1,
    style: { "height": "16px" }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { key: 2 };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "title" };
import { ref, watch, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DrawerPanel',
    props: {
        title: {},
        icon: {},
        iconBgColour: {},
        backgroundColor: {},
        openBackgroundColor: {},
        bottom: {},
        openHeight: {},
        closedHeight: {},
        startOpened: { type: Boolean },
        blurBackground: { type: Boolean },
        back: { type: Boolean },
        contentAlwaysVisible: { type: Boolean },
        confirmClose: {},
        divider: { type: Boolean, default: true },
        close: { type: Boolean },
        keyboard: { type: Boolean },
        closeBackground: { type: Boolean },
        transitionDuration: {},
        safeAreaPadding: { type: Boolean },
        hideNavBar: { type: Boolean }
    },
    emits: ["opened", "closed", "goBack"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const drawerHeight = ref(props.closedHeight ?? "82px");
        const drawer = ref(false);
        const blur = ref(true);
        const dragOffset = ref(0);
        const isDragging = ref(false);
        let touchStartY = 0;
        let panelHeight = 0;
        function onTouchStart(e) {
            if (!drawer.value)
                return;
            touchStartY = e.touches[0].clientY;
            const panel = e.currentTarget.closest('.drawer');
            panelHeight = panel?.offsetHeight ?? window.innerHeight;
            isDragging.value = true;
        }
        function onTouchMove(e) {
            if (!isDragging.value)
                return;
            e.preventDefault();
            dragOffset.value = Math.max(0, e.touches[0].clientY - touchStartY);
        }
        function onTouchEnd() {
            if (!isDragging.value)
                return;
            const shouldClose = dragOffset.value > panelHeight * 0.25;
            isDragging.value = false;
            dragOffset.value = 0;
            if (shouldClose)
                closeDrawer();
        }
        function canCloseDrawer() {
            if (drawer.value && props.confirmClose && typeof props.confirmClose === 'function') {
                return props.confirmClose();
            }
            return true;
        }
        function toggleDrawer() {
            if (!canCloseDrawer()) {
                return;
            }
            drawer.value = !drawer.value;
            if (!drawer.value) {
                drawerHeight.value = props.closedHeight ?? "82px";
                if (props.hideNavBar) {
                    document.body.classList.remove('hide-nav-bar');
                }
                emit("closed");
            }
            else {
                drawerHeight.value = props.openHeight ?? "80%";
                if (props.hideNavBar) {
                    document.body.classList.add('hide-nav-bar');
                }
                emit("opened");
            }
        }
        function openDrawer() {
            drawer.value = true;
            drawerHeight.value = props.openHeight ?? "80%";
            if (props.hideNavBar) {
                document.body.classList.add('hide-nav-bar');
            }
            emit("opened");
        }
        function closeDrawer() {
            if (!canCloseDrawer()) {
                return;
            }
            drawer.value = false;
            drawerHeight.value = props.closedHeight ?? "82px";
            if (props.hideNavBar) {
                document.body.classList.remove('hide-nav-bar');
            }
            emit("closed");
        }
        watch(() => props.openHeight, (newHeight) => {
            if (drawer.value) {
                drawerHeight.value = newHeight ?? "80%";
            }
        });
        onMounted(() => {
            if (props.startOpened) {
                toggleDrawer();
            }
            if (props.blurBackground !== null && props.blurBackground !== undefined) {
                blur.value = props.blurBackground;
            }
            else {
                blur.value = true;
            }
        });
        __expose({ openDrawer, closeDrawer, toggleDrawer, drawer });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_divider = _resolveComponent("v-divider");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (drawer.value && blur.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "bg",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.closeBackground ? toggleDrawer() : null))
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", {
                    class: _normalizeClass(["drawer",
                        {
                            'position-absolute': _ctx.keyboard,
                            'position-fixed': !_ctx.keyboard,
                            'no-transition': _ctx.keyboard,
                            'hide-nav-drawer': _ctx.hideNavBar
                        }
                    ]),
                    style: _normalizeStyle('bottom: ' + _ctx.bottom + '; background-color: ' + (drawer.value ? _ctx.openBackgroundColor : _ctx.backgroundColor) + '; height: ' + drawerHeight.value + '; transition: ' + (isDragging.value ? 'none' : 'all ' + _ctx.transitionDuration + ' ease-out') + ';' + (_ctx.safeAreaPadding ? ' padding-top: 44px;' : '') + (dragOffset.value > 0 ? ' transform: translateY(' + dragOffset.value + 'px);' : '')),
                    onClick: toggleDrawer
                }, [
                    _createVNode(_component_v_list_item, {
                        class: "drawer-header",
                        style: { "text-align": "center" },
                        onTouchstartPassive: onTouchStart,
                        onTouchmove: onTouchMove,
                        onTouchend: onTouchEnd,
                        onTouchcancel: onTouchEnd
                    }, {
                        default: _withCtx(() => [
                            (_ctx.divider)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_2)),
                            _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "2" }, {
                                        default: _withCtx(() => [
                                            (_ctx.back)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "mg-circle-image-button",
                                                    onClick: _cache[1] || (_cache[1] = event => { event.stopPropagation(); emit('goBack'); })
                                                }, [
                                                    _createVNode(_component_v_icon, { icon: "mdi-arrow-left" })
                                                ]))
                                                : (_ctx.icon && _ctx.iconBgColour)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: "cardIconCircle",
                                                        style: _normalizeStyle({ backgroundColor: _ctx.iconBgColour })
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: _ctx.icon,
                                                            class: "cardIconInner"
                                                        }, null, 8, _hoisted_3)
                                                    ], 4))
                                                    : (_ctx.icon)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                            _createElementVNode("img", {
                                                                src: _ctx.icon,
                                                                class: "cardIcon"
                                                            }, null, 8, _hoisted_5)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.title), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "2" }, {
                                        default: _withCtx(() => [
                                            (drawer.value && _ctx.close)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _imports_0,
                                                    class: "close-icon",
                                                    onClick: _cache[2] || (_cache[2] = event => { event.stopPropagation(); closeDrawer(); })
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (_ctx.divider)
                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "panelContent",
                        onClick: _cache[3] || (_cache[3] = event => { event.stopPropagation(); })
                    }, [
                        (drawer.value || _ctx.contentAlwaysVisible)
                            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
                            : _createCommentVNode("", true)
                    ])
                ], 6)
            ], 64));
        };
    }
});
